import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {
  FaTimes,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileImage,
  FaFileAlt,
  FaFile,
} from 'react-icons/fa';
import { useI18n } from '../../i18n';
import meetingService from '../../services/meetingService';
import { notify } from '../CustomToast';
import api from '../../api';
import { parseDate } from '../../utils/dateUtils';
import ViewMeetingModalSkeleton from './ViewMeetingModalSkeleton';
import MeetingAttachmentPreviewModal from './MeetingAttachmentPreviewModal';
import '../Projects/ProjectComposer.css';
import './ViewMeetingModal.css';

const CalendarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 2H11.5V1.5C11.5 1.36739 11.4473 1.24021 11.3536 1.14645C11.2598 1.05268 11.1326 1 11 1C10.8674 1 10.7402 1.05268 10.6464 1.14645C10.5527 1.24021 10.5 1.36739 10.5 1.5V2H5.5V1.5C5.5 1.36739 5.44732 1.24021 5.35355 1.14645C5.25979 1.05268 5.13261 1 5 1C4.86739 1 4.74021 1.05268 4.64645 1.14645C4.55268 1.24021 4.5 1.36739 4.5 1.5V2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM4.5 3V3.5C4.5 3.63261 4.55268 3.75979 4.64645 3.85355C4.74021 3.94732 4.86739 4 5 4C5.13261 4 5.25979 3.94732 5.35355 3.85355C5.44732 3.75979 5.5 3.63261 5.5 3.5V3H10.5V3.5C10.5 3.63261 10.5527 3.75979 10.6464 3.85355C10.7402 3.94732 10.8674 4 11 4C11.1326 4 11.2598 3.94732 11.3536 3.85355C11.4473 3.75979 11.5 3.63261 11.5 3.5V3H13V5H3V3H4.5ZM13 13H3V6H13V13ZM8.75 8.25C8.75 8.39834 8.70601 8.54334 8.6236 8.66668C8.54119 8.79001 8.42406 8.88614 8.28701 8.94291C8.14997 8.99967 7.99917 9.01453 7.85368 8.98559C7.7082 8.95665 7.57456 8.88522 7.46967 8.78033C7.36478 8.67544 7.29335 8.5418 7.26441 8.39632C7.23547 8.25083 7.25032 8.10003 7.30709 7.96299C7.36386 7.82594 7.45999 7.70881 7.58332 7.6264C7.70666 7.54399 7.85166 7.5 8 7.5C8.19891 7.5 8.38968 7.57902 8.53033 7.71967C8.67098 7.86032 8.75 8.05109 8.75 8.25ZM11.5 8.25C11.5 8.39834 11.456 8.54334 11.3736 8.66668C11.2912 8.79001 11.1741 8.88614 11.037 8.94291C10.9 8.99967 10.7492 9.01453 10.6037 8.98559C10.4582 8.95665 10.3246 8.88522 10.2197 8.78033C10.1148 8.67544 10.0433 8.5418 10.0144 8.39632C9.98547 8.25083 10.0003 8.10003 10.0571 7.96299C10.1139 7.82594 10.21 7.70881 10.3333 7.6264C10.4567 7.54399 10.6017 7.5 10.75 7.5C10.9489 7.5 11.1397 7.57902 11.2803 7.71967C11.421 7.86032 11.5 8.05109 11.5 8.25ZM6 10.75C6 10.8983 5.95601 11.0433 5.8736 11.1667C5.79119 11.29 5.67406 11.3861 5.53701 11.4429C5.39997 11.4997 5.24917 11.5145 5.10368 11.4856C4.9582 11.4567 4.82456 11.3852 4.71967 11.2803C4.61478 11.1754 4.54335 11.0418 4.51441 10.8963C4.48547 10.7508 4.50032 10.6 4.55709 10.463C4.61386 10.3259 4.70999 10.2088 4.83332 10.1264C4.95666 10.044 5.10166 10 5.25 10C5.44891 10 5.63968 10.079 5.78033 10.2197C5.92098 10.3603 6 10.5511 6 10.75ZM8.75 10.75C8.75 10.8983 8.70601 11.0433 8.6236 11.1667C8.54119 11.29 8.42406 11.3861 8.28701 11.4429C8.14997 11.4997 7.99917 11.5145 7.85368 11.4856C7.7082 11.4567 7.57456 11.3852 7.46967 11.2803C7.36478 11.1754 7.29335 11.0418 7.26441 10.8963C7.23547 10.7508 7.25032 10.6 7.30709 10.463C7.36386 10.3259 7.45999 10.2088 7.58332 10.1264C7.70666 10.044 7.85166 10 8 10C8.19891 10 8.38968 10.079 8.53033 10.2197C8.67098 10.3603 8.75 10.5511 8.75 10.75ZM11.5 10.75C11.5 10.8983 11.456 11.0433 11.3736 11.1667C11.2912 11.29 11.1741 11.3861 11.037 11.4429C10.9 11.4997 10.7492 11.5145 10.6037 11.4856C10.4582 11.4567 10.3246 11.3852 10.2197 11.2803C10.1148 11.1754 10.0433 11.0418 10.0144 10.8963C9.98547 10.7508 10.0003 10.6 10.0571 10.463C10.1139 10.3259 10.21 10.2088 10.3333 10.1264C10.4567 10.044 10.6017 10 10.75 10C10.9489 10 11.1397 10.079 11.2803 10.2197C11.421 10.3603 11.5 10.5511 11.5 10.75Z"
      fill="#343330"
      fillOpacity="0.85"
    />
  </svg>
);

const DownloadIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 12.75V18.75C22.5 19.1478 22.342 19.5294 22.0607 19.8107C21.7794 20.092 21.3978 20.25 21 20.25H3C2.60218 20.25 2.22064 20.092 1.93934 19.8107C1.65804 19.5294 1.5 19.1478 1.5 18.75V12.75C1.5 12.3522 1.65804 11.9706 1.93934 11.6893C2.22064 11.408 2.60218 11.25 3 11.25H6.75C6.94891 11.25 7.13968 11.329 7.28033 11.4697C7.42098 11.6103 7.5 11.8011 7.5 12C7.5 12.1989 7.42098 12.3897 7.28033 12.5303C7.13968 12.671 6.94891 12.75 6.75 12.75H3V18.75H21V12.75H17.25C17.0511 12.75 16.8603 12.671 16.7197 12.5303C16.579 12.3897 16.5 12.1989 16.5 12C16.5 11.8011 16.579 11.6103 16.7197 11.4697C16.8603 11.329 17.0511 11.25 17.25 11.25H21C21.3978 11.25 21.7794 11.408 22.0607 11.6893C22.342 11.9706 22.5 12.3522 22.5 12.75ZM11.4694 12.5306C11.539 12.6004 11.6217 12.6557 11.7128 12.6934C11.8038 12.7312 11.9014 12.7506 12 12.7506C12.0986 12.7506 12.1962 12.7312 12.2872 12.6934C12.3783 12.6557 12.461 12.6004 12.5306 12.5306L17.0306 8.03063C17.1714 7.88989 17.2504 7.69902 17.2504 7.5C17.2504 7.30098 17.1714 7.11011 17.0306 6.96937C16.8899 6.82864 16.699 6.74958 16.5 6.74958C16.301 6.74958 16.1101 6.82864 15.9694 6.96937L12.75 10.1897V2.25C12.75 2.05109 12.671 1.86032 12.5303 1.71967C12.3897 1.57902 12.1989 1.5 12 1.5C11.8011 1.5 11.6103 1.57902 11.4697 1.71967C11.329 1.86032 11.25 2.05109 11.25 2.25V10.1897L8.03063 6.96937C7.88989 6.82864 7.69902 6.74958 7.5 6.74958C7.30098 6.74958 7.11011 6.82864 6.96938 6.96938C6.82864 7.11011 6.74958 7.30098 6.74958 7.5C6.74958 7.69902 6.82864 7.88989 6.96937 8.03063L11.4694 12.5306ZM18.75 15.75C18.75 15.5275 18.684 15.31 18.5604 15.125C18.4368 14.94 18.2611 14.7958 18.0555 14.7106C17.85 14.6255 17.6238 14.6032 17.4055 14.6466C17.1873 14.69 16.9868 14.7972 16.8295 14.9545C16.6722 15.1118 16.565 15.3123 16.5216 15.5305C16.4782 15.7488 16.5005 15.975 16.5856 16.1805C16.6708 16.3861 16.815 16.5618 17 16.6854C17.185 16.809 17.4025 16.875 17.625 16.875C17.9234 16.875 18.2095 16.7565 18.4205 16.5455C18.6315 16.3345 18.75 16.0484 18.75 15.75Z"
      fill="#343330"
    />
  </svg>
);

const ViewIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.1853 11.6962C23.1525 11.6222 22.3584 9.86062 20.5931 8.09531C18.2409 5.74312 15.27 4.5 12 4.5C8.72999 4.5 5.75905 5.74312 3.40687 8.09531C1.64155 9.86062 0.843741 11.625 0.814679 11.6962C0.772035 11.7922 0.75 11.896 0.75 12.0009C0.75 12.1059 0.772035 12.2097 0.814679 12.3056C0.847491 12.3797 1.64155 14.1403 3.40687 15.9056C5.75905 18.2569 8.72999 19.5 12 19.5C15.27 19.5 18.2409 18.2569 20.5931 15.9056C22.3584 14.1403 23.1525 12.3797 23.1853 12.3056C23.2279 12.2097 23.25 12.1059 23.25 12.0009C23.25 11.896 23.2279 11.7922 23.1853 11.6962ZM12 18C9.11437 18 6.59343 16.9509 4.50655 14.8828C3.65028 14.0313 2.92179 13.0603 2.34374 12C2.92164 10.9396 3.65014 9.9686 4.50655 9.11719C6.59343 7.04906 9.11437 6 12 6C14.8856 6 17.4066 7.04906 19.4934 9.11719C20.3514 9.9684 21.0815 10.9394 21.6609 12C20.985 13.2619 18.0403 18 12 18ZM12 7.5C11.11 7.5 10.2399 7.76392 9.49993 8.25839C8.7599 8.75285 8.18313 9.45566 7.84253 10.2779C7.50194 11.1002 7.41282 12.005 7.58646 12.8779C7.76009 13.7508 8.18867 14.5526 8.81801 15.182C9.44735 15.8113 10.2492 16.2399 11.1221 16.4135C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2471 15.2401 15.7416 14.5001C16.2361 13.76 16.5 12.89 16.5 12C16.4988 10.8069 16.0242 9.66303 15.1806 8.81939C14.337 7.97575 13.1931 7.50124 12 7.5ZM12 15C11.4066 15 10.8266 14.8241 10.3333 14.4944C9.83993 14.1648 9.45542 13.6962 9.22835 13.1481C9.00129 12.5999 8.94188 11.9967 9.05764 11.4147C9.17339 10.8328 9.45911 10.2982 9.87867 9.87868C10.2982 9.45912 10.8328 9.1734 11.4147 9.05764C11.9967 8.94189 12.5999 9.0013 13.148 9.22836C13.6962 9.45542 14.1648 9.83994 14.4944 10.3333C14.824 10.8266 15 11.4067 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15Z"
      fill="#343330"
    />
  </svg>
);

const OccurrenceIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.50039 8.00028C1.50172 6.80721 1.97625 5.66339 2.81987 4.81976C3.6635 3.97613 4.80733 3.5016 6.00039 3.50028H12.7935L12.1466 2.85403C12.0528 2.76021 12.0001 2.63296 12.0001 2.50028C12.0001 2.3676 12.0528 2.24035 12.1466 2.14653C12.2405 2.05271 12.3677 2 12.5004 2C12.6331 2 12.7603 2.05271 12.8541 2.14653L14.3541 3.64653C14.4006 3.69296 14.4375 3.74811 14.4627 3.80881C14.4878 3.86951 14.5008 3.93457 14.5008 4.00028C14.5008 4.06599 14.4878 4.13105 14.4627 4.19175C14.4375 4.25245 14.4006 4.30759 14.3541 4.35403L12.8541 5.85403C12.7603 5.94785 12.6331 6.00056 12.5004 6.00056C12.3677 6.00056 12.2405 5.94785 12.1466 5.85403C12.0528 5.76021 12.0001 5.63296 12.0001 5.50028C12.0001 5.3676 12.0528 5.24035 12.1466 5.14653L12.7935 4.50028H6.00039C5.07244 4.50127 4.18278 4.87034 3.52662 5.5265C2.87045 6.18266 2.50139 7.07232 2.50039 8.00028C2.50039 8.13289 2.44771 8.26006 2.35395 8.35383C2.26018 8.4476 2.133 8.50028 2.00039 8.50028C1.86779 8.50028 1.74061 8.4476 1.64684 8.35383C1.55307 8.26006 1.50039 8.13289 1.50039 8.00028ZM14.0004 7.50028C13.8678 7.50028 13.7406 7.55296 13.6468 7.64672C13.5531 7.74049 13.5004 7.86767 13.5004 8.00028C13.4994 8.92823 13.1303 9.81789 12.4742 10.4741C11.818 11.1302 10.9283 11.4993 10.0004 11.5003H3.20727L3.85414 10.854C3.9006 10.8076 3.93745 10.7524 3.96259 10.6917C3.98773 10.631 4.00067 10.566 4.00067 10.5003C4.00067 10.4346 3.98773 10.3695 3.96259 10.3088C3.93745 10.2481 3.9006 10.193 3.85414 10.1465C3.80769 10.1001 3.75254 10.0632 3.69184 10.0381C3.63115 10.0129 3.56609 10 3.50039 10C3.4347 10 3.36964 10.0129 3.30895 10.0381C3.24825 10.0632 3.1931 10.1001 3.14664 10.1465L1.64664 11.6465C1.60016 11.693 1.56328 11.7481 1.53811 11.8088C1.51295 11.8695 1.5 11.9346 1.5 12.0003C1.5 12.066 1.51295 12.131 1.53811 12.1917C1.56328 12.2524 1.60016 12.3076 1.64664 12.354L3.14664 13.854C3.1931 13.9005 3.24825 13.9373 3.30895 13.9625C3.36964 13.9876 3.4347 14.0006 3.50039 14.0006C3.56609 14.0006 3.63115 13.9876 3.69184 13.9625C3.75254 13.9373 3.80769 13.9005 3.85414 13.854C3.9006 13.8076 3.93745 13.7524 3.96259 13.6917C3.98773 13.631 4.00067 13.566 4.00067 13.5003C4.00067 13.4346 3.98773 13.3695 3.96259 13.3088C3.93745 13.2481 3.9006 13.193 3.85414 13.1465L3.20727 12.5003H10.0004C11.1935 12.499 12.3373 12.0244 13.1809 11.1808C14.0245 10.3372 14.4991 9.19335 14.5004 8.00028C14.5004 7.86767 14.4477 7.74049 14.3539 7.64672C14.2602 7.55296 14.133 7.50028 14.0004 7.50028Z"
      fill="#343330"
      fill-opacity="0.85"
    />
  </svg>
);

const AttendeesIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2502 14.1008C12.1531 13.3418 12.8008 12.3235 13.1054 11.1839C13.41 10.0443 13.3567 8.8386 12.9528 7.73031C12.5489 6.62202 11.8139 5.66478 10.8475 4.98839C9.88105 4.31201 8.72999 3.94922 7.5504 3.94922C6.3708 3.94922 5.21974 4.31201 4.25333 4.98839C3.28692 5.66478 2.55191 6.62202 2.148 7.73031C1.74408 8.8386 1.6908 10.0443 1.99538 11.1839C2.29995 12.3235 2.94765 13.3418 3.85063 14.1008C2.4406 14.7384 1.21867 15.7286 0.3027 16.9758C0.133521 17.2064 0.0628508 17.4947 0.106237 17.7773C0.149623 18.06 0.303511 18.3138 0.534047 18.483C0.764584 18.6521 1.05288 18.7228 1.33553 18.6794C1.61817 18.636 1.872 18.4822 2.04118 18.2516C2.67524 17.3856 3.50452 16.6813 4.46172 16.1958C5.41893 15.7103 6.47711 15.4573 7.5504 15.4573C8.62369 15.4573 9.68186 15.7103 10.6391 16.1958C11.5963 16.6813 12.4255 17.3856 13.0596 18.2516C13.2288 18.4823 13.4827 18.6363 13.7654 18.6797C14.0481 18.7232 14.3365 18.6526 14.5672 18.4834C14.7978 18.3142 14.9518 18.0604 14.9953 17.7776C15.0388 17.4949 14.9682 17.2065 14.799 16.9758C13.8825 15.7287 12.6603 14.7386 11.2502 14.1008ZM3.95665 9.70388C3.95665 8.99311 4.16741 8.29829 4.5623 7.7073C4.95719 7.11631 5.51846 6.65569 6.17513 6.38369C6.8318 6.11169 7.55438 6.04052 8.2515 6.17919C8.94862 6.31785 9.58897 6.66012 10.0916 7.16272C10.5942 7.66531 10.9364 8.30566 11.0751 9.00278C11.2138 9.6999 11.1426 10.4225 10.8706 11.0792C10.5986 11.7358 10.138 12.2971 9.54698 12.692C8.95599 13.0869 8.26117 13.2976 7.5504 13.2976C6.59727 13.2976 5.68319 12.919 5.00923 12.245C4.33527 11.5711 3.95665 10.657 3.95665 9.70388ZM22.4734 18.4789C22.3593 18.5628 22.2298 18.6233 22.0922 18.6571C21.9547 18.6909 21.8118 18.6973 21.6718 18.6758C21.5318 18.6544 21.3974 18.6056 21.2763 18.5322C21.1551 18.4588 21.0497 18.3622 20.9659 18.248C20.3302 17.3837 19.5006 16.6806 18.5438 16.1953C17.5869 15.71 16.5295 15.4561 15.4566 15.4539C15.1707 15.4539 14.8965 15.3403 14.6943 15.1381C14.4921 14.9359 14.3785 14.6617 14.3785 14.3758C14.3785 14.0898 14.4921 13.8156 14.6943 13.6134C14.8965 13.4112 15.1707 13.2976 15.4566 13.2976C15.9674 13.2967 16.4722 13.1869 16.9372 12.9756C17.4022 12.7642 17.8168 12.4562 18.1534 12.072C18.49 11.6878 18.7408 11.2362 18.8891 10.7474C19.0375 10.2586 19.0799 9.74383 19.0136 9.23735C18.9473 8.73088 18.7737 8.24436 18.5046 7.81023C18.2354 7.3761 17.8768 7.00433 17.4527 6.71972C17.0285 6.4351 16.5486 6.24417 16.0448 6.15966C15.5411 6.07516 15.0251 6.09901 14.5313 6.22963C14.3933 6.26953 14.2488 6.28148 14.1062 6.26478C13.9636 6.24808 13.8258 6.20306 13.7008 6.13238C13.5759 6.06169 13.4663 5.96675 13.3785 5.85314C13.2907 5.73952 13.2265 5.60952 13.1896 5.47076C13.1528 5.33199 13.144 5.18726 13.1638 5.04506C13.1837 4.90286 13.2317 4.76606 13.3051 4.64267C13.3785 4.51929 13.4759 4.41181 13.5914 4.32655C13.7069 4.24128 13.8383 4.17995 13.9778 4.14615C15.2405 3.81157 16.5795 3.91692 17.7744 4.44485C18.9693 4.97279 19.9487 5.89183 20.5516 7.0507C21.1545 8.20956 21.3448 9.53915 21.0912 10.8206C20.8376 12.102 20.1552 13.2589 19.1564 14.1008C20.5664 14.7384 21.7884 15.7286 22.7043 16.9758C22.8723 17.206 22.9423 17.4934 22.899 17.775C22.8558 18.0567 22.7028 18.3098 22.4734 18.4789Z"
      fill="#343330"
      fillOpacity="0.85"
    />
  </svg>
);

const LocationIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 4C7.50555 4 7.0222 4.14662 6.61107 4.42133C6.19995 4.69603 5.87952 5.08648 5.6903 5.54329C5.50108 6.00011 5.45157 6.50277 5.54804 6.98773C5.6445 7.47268 5.8826 7.91814 6.23223 8.26777C6.58186 8.6174 7.02732 8.8555 7.51227 8.95196C7.99723 9.04843 8.49989 8.99892 8.95671 8.8097C9.41352 8.62048 9.80397 8.30005 10.0787 7.88893C10.3534 7.4778 10.5 6.99445 10.5 6.5C10.5 5.83696 10.2366 5.20107 9.76777 4.73223C9.29893 4.26339 8.66304 4 8 4ZM8 8C7.70333 8 7.41332 7.91203 7.16664 7.7472C6.91997 7.58238 6.72771 7.34811 6.61418 7.07403C6.50065 6.79994 6.47094 6.49834 6.52882 6.20736C6.5867 5.91639 6.72956 5.64912 6.93934 5.43934C7.14912 5.22956 7.41639 5.0867 7.70736 5.02882C7.99834 4.97094 8.29994 5.00065 8.57403 5.11418C8.84811 5.22771 9.08238 5.41997 9.2472 5.66664C9.41203 5.91332 9.5 6.20333 9.5 6.5C9.5 6.89782 9.34196 7.27936 9.06066 7.56066C8.77936 7.84196 8.39782 8 8 8ZM8 1C6.54182 1.00165 5.14383 1.58165 4.11274 2.61274C3.08165 3.64383 2.50165 5.04182 2.5 6.5C2.5 8.4625 3.40688 10.5425 5.125 12.5156C5.89701 13.4072 6.76591 14.2101 7.71562 14.9094C7.7997 14.9683 7.89985 14.9999 8.0025 14.9999C8.10515 14.9999 8.20531 14.9683 8.28938 14.9094C9.23734 14.2098 10.1046 13.4069 10.875 12.5156C12.5906 10.5425 13.5 8.4625 13.5 6.5C13.4983 5.04182 12.9184 3.64383 11.8873 2.61274C10.8562 1.58165 9.45818 1.00165 8 1ZM8 13.875C6.96688 13.0625 3.5 10.0781 3.5 6.5C3.5 5.30653 3.97411 4.16193 4.81802 3.31802C5.66193 2.47411 6.80653 2 8 2C9.19347 2 10.3381 2.47411 11.182 3.31802C12.0259 4.16193 12.5 5.30653 12.5 6.5C12.5 10.0769 9.03312 13.0625 8 13.875Z"
      fill="#343330"
      fillOpacity="0.85"
    />
  </svg>
);

const StatusIcon = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00028 1.00028C5.81359 1.00028 4.65355 1.35217 3.66686 2.01146C2.68016 2.67075 1.91113 3.60782 1.457 4.70418C1.00287 5.80053 0.884055 7.00693 1.11557 8.17082C1.34708 9.33471 1.91852 10.4038 2.75764 11.2429C3.59675 12.082 4.66585 12.6535 5.82974 12.885C6.99362 13.1165 8.20002 12.9977 9.29638 12.5436C10.3927 12.0894 11.3298 11.3204 11.9891 10.3337C12.6484 9.34701 13.0003 8.18697 13.0003 7.00028C12.9985 5.40954 12.3657 3.88447 11.2409 2.75965C10.1161 1.63482 8.59102 1.0021 7.00028 1.00028ZM7.00028 12.0003C6.01137 12.0003 5.04467 11.707 4.22243 11.1576C3.40018 10.6082 2.75932 9.82732 2.38088 8.91369C2.00244 8.00006 1.90343 6.99473 2.09635 6.02483C2.28928 5.05492 2.76548 4.16401 3.46474 3.46474C4.16401 2.76548 5.05492 2.28928 6.02483 2.09635C6.99473 1.90343 8.00006 2.00244 8.9137 2.38088C9.82733 2.75932 10.6082 3.40018 11.1576 4.22243C11.707 5.04467 12.0003 6.01137 12.0003 7.00028C11.9988 8.3259 11.4715 9.59681 10.5342 10.5342C9.59681 11.4715 8.3259 11.9988 7.00028 12.0003ZM2.85403 0.854028L0.854028 2.85403C0.760208 2.94785 0.63296 3.00056 0.500278 3.00056C0.367596 3.00056 0.240348 2.94785 0.146528 2.85403C0.0527077 2.76021 1.39803e-09 2.63296 0 2.50028C-1.39803e-09 2.3676 0.0527077 2.24035 0.146528 2.14653L2.14653 0.146528C2.24035 0.0527077 2.3676 0 2.50028 0C2.63296 0 2.76021 0.0527077 2.85403 0.146528C2.94785 0.240348 3.00056 0.367596 3.00056 0.500278C3.00056 0.63296 2.94785 0.760208 2.85403 0.854028ZM13.854 2.85403C13.8076 2.90052 13.7524 2.9374 13.6917 2.96256C13.631 2.98772 13.566 3.00067 13.5003 3.00067C13.4346 3.00067 13.3695 2.98772 13.3088 2.96256C13.2481 2.9374 13.193 2.90052 13.1465 2.85403L11.1465 0.854028C11.0527 0.760208 11 0.63296 11 0.500278C11 0.367596 11.0527 0.240348 11.1465 0.146528C11.2403 0.0527077 11.3676 2.61548e-09 11.5003 0C11.633 -2.61548e-09 11.7602 0.0527077 11.854 0.146528L13.854 2.14653C13.9005 2.19296 13.9374 2.24811 13.9626 2.30881C13.9877 2.36951 14.0007 2.43457 14.0007 2.50028C14.0007 2.56599 13.9877 2.63105 13.9626 2.69175C13.9374 2.75245 13.9005 2.80759 13.854 2.85403ZM10.5003 6.50028C10.6329 6.50028 10.7601 6.55296 10.8538 6.64672C10.9476 6.74049 11.0003 6.86767 11.0003 7.00028C11.0003 7.13289 10.9476 7.26006 10.8538 7.35383C10.7601 7.4476 10.6329 7.50028 10.5003 7.50028H7.00028C6.86767 7.50028 6.74049 7.4476 6.64672 7.35383C6.55296 7.26006 6.50028 7.13289 6.50028 7.00028V3.50028C6.50028 3.36767 6.55296 3.24049 6.64672 3.14672C6.74049 3.05296 6.86767 3.00028 7.00028 3.00028C7.13289 3.00028 7.26006 3.05296 7.35383 3.14672C7.4476 3.24049 7.50028 3.36767 7.50028 3.50028V6.50028H10.5003Z"
      fill="#343330"
      fillOpacity="0.85"
    />
  </svg>
);

const TimeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 13.5C6.91221 13.5 5.84884 13.1774 4.94437 12.5731C4.0399 11.9687 3.33495 11.1098 2.91867 10.1048C2.50238 9.09977 2.39347 7.9939 2.60568 6.927C2.8179 5.86011 3.34173 4.8801 4.11092 4.11091C4.8801 3.34172 5.86011 2.8179 6.92701 2.60568C7.9939 2.39346 9.09977 2.50238 10.1048 2.91866C11.1098 3.33494 11.9687 4.03989 12.5731 4.94436C13.1774 5.84883 13.5 6.9122 13.5 8C13.4983 9.45818 12.9184 10.8562 11.8873 11.8873C10.8562 12.9184 9.45819 13.4983 8 13.5ZM12 8C12 8.13261 11.9473 8.25979 11.8536 8.35355C11.7598 8.44732 11.6326 8.5 11.5 8.5H8C7.86739 8.5 7.74022 8.44732 7.64645 8.35355C7.55268 8.25979 7.5 8.13261 7.5 8V4.5C7.5 4.36739 7.55268 4.24021 7.64645 4.14645C7.74022 4.05268 7.86739 4 8 4C8.13261 4 8.25979 4.05268 8.35356 4.14645C8.44732 4.24021 8.5 4.36739 8.5 4.5V7.5H11.5C11.6326 7.5 11.7598 7.55268 11.8536 7.64645C11.9473 7.74021 12 7.86739 12 8Z"
      fill="#343330"
      fill-opacity="0.85"
    />
  </svg>
);

const AVATAR_COLORS = [
  '#7c3aed',
  '#a855f7',
  '#0d9488',
  '#2563eb',
  '#e11d48',
  '#d97706',
  '#16a34a',
  '#0891b2',
];

const getAvatarColor = (index) => AVATAR_COLORS[index % AVATAR_COLORS.length];

const formatTranscriptionTime = (totalSeconds) => {
  const m = Math.floor(totalSeconds / 60);
  const s = Math.floor(totalSeconds % 60);
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

const MeetingMinutesIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.25 10.5C17.25 10.6989 17.171 10.8897 17.0303 11.0303C16.8897 11.171 16.6989 11.25 16.5 11.25H10.5C10.3011 11.25 10.1103 11.171 9.96967 11.0303C9.82902 10.8897 9.75 10.6989 9.75 10.5C9.75 10.3011 9.82902 10.1103 9.96967 9.96967C10.1103 9.82902 10.3011 9.75 10.5 9.75H16.5C16.6989 9.75 16.8897 9.82902 17.0303 9.96967C17.171 10.1103 17.25 10.3011 17.25 10.5ZM16.5 12.75H10.5C10.3011 12.75 10.1103 12.829 9.96967 12.9697C9.82902 13.1103 9.75 13.3011 9.75 13.5C9.75 13.6989 9.82902 13.8897 9.96967 14.0303C10.1103 14.171 10.3011 14.25 10.5 14.25H16.5C16.6989 14.25 16.8897 14.171 17.0303 14.0303C17.171 13.8897 17.25 13.6989 17.25 13.5C17.25 13.3011 17.171 13.1103 17.0303 12.9697C16.8897 12.829 16.6989 12.75 16.5 12.75ZM21 4.5V19.5C21 19.8978 20.842 20.2794 20.5607 20.5607C20.2794 20.842 19.8978 21 19.5 21H4.5C4.10218 21 3.72064 20.842 3.43934 20.5607C3.15804 20.2794 3 19.8978 3 19.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H19.5C19.8978 3 20.2794 3.15804 20.5607 3.43934C20.842 3.72064 21 4.10218 21 4.5ZM4.5 19.5H6.75V4.5H4.5V19.5ZM19.5 19.5V4.5H8.25V19.5H19.5Z"
      fill="#0C5097"
    />
  </svg>
);

const UploadIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 13.5006V19.5006C21 19.6995 20.921 19.8903 20.7803 20.0309C20.6397 20.1716 20.4489 20.2506 20.25 20.2506H3.75C3.55109 20.2506 3.36032 20.1716 3.21967 20.0309C3.07902 19.8903 3 19.6995 3 19.5006V13.5006C3 13.3017 3.07902 13.1109 3.21967 12.9703C3.36032 12.8296 3.55109 12.7506 3.75 12.7506C3.94891 12.7506 4.13968 12.8296 4.28033 12.9703C4.42098 13.1109 4.5 13.3017 4.5 13.5006V18.7506H19.5V13.5006C19.5 13.3017 19.579 13.1109 19.7197 12.9703C19.8603 12.8296 20.0511 12.7506 20.25 12.7506C20.4489 12.7506 20.6397 12.8296 20.7803 12.9703C20.921 13.1109 21 13.3017 21 13.5006ZM8.78063 7.28122L11.25 4.8109V13.5006C11.25 13.6995 11.329 13.8903 11.4697 14.0309C11.6103 14.1716 11.8011 14.2506 12 14.2506C12.1989 14.2506 12.3897 14.1716 12.5303 14.0309C12.671 13.8903 12.75 13.6995 12.75 13.5006V4.8109L15.2194 7.28122C15.3601 7.42195 15.551 7.50101 15.75 7.50101C15.949 7.50101 16.1399 7.42195 16.2806 7.28122C16.4214 7.14048 16.5004 6.94961 16.5004 6.75059C16.5004 6.55157 16.4214 6.3607 16.2806 6.21996L12.5306 2.46996C12.461 2.40023 12.3783 2.34491 12.2872 2.30717C12.1962 2.26943 12.0986 2.25 12 2.25C11.9014 2.25 11.8038 2.26943 11.7128 2.30717C11.6217 2.34491 11.539 2.40023 11.4694 2.46996L7.71937 6.21996C7.57864 6.3607 7.49958 6.55157 7.49958 6.75059C7.49958 6.94961 7.57864 7.14048 7.71937 7.28122C7.86011 7.42195 8.05098 7.50101 8.25 7.50101C8.44902 7.50101 8.63989 7.42195 8.78063 7.28122Z"
      fill="#343330"
      fillOpacity="0.85"
    />
  </svg>
);

const CopyMinutesIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7656 12.1717C12.7656 12.4079 12.6718 12.6345 12.5048 12.8015C12.3377 12.9685 12.1112 13.0623 11.875 13.0623H7.125C6.88879 13.0623 6.66226 12.9685 6.49523 12.8015C6.32821 12.6345 6.23438 12.4079 6.23438 12.1717C6.23438 11.9355 6.32821 11.709 6.49523 11.5419C6.66226 11.3749 6.88879 11.2811 7.125 11.2811H11.875C12.1112 11.2811 12.3377 11.3749 12.5048 11.5419C12.6718 11.709 12.7656 11.9355 12.7656 12.1717ZM11.875 8.31234H7.125C6.88879 8.31234 6.66226 8.40617 6.49523 8.57319C6.32821 8.74022 6.23438 8.96675 6.23438 9.20296C6.23438 9.43917 6.32821 9.6657 6.49523 9.83273C6.66226 9.99975 6.88879 10.0936 7.125 10.0936H11.875C12.1112 10.0936 12.3377 9.99975 12.5048 9.83273C12.6718 9.6657 12.7656 9.43917 12.7656 9.20296C12.7656 8.96675 12.6718 8.74022 12.5048 8.57319C12.3377 8.40617 12.1112 8.31234 11.875 8.31234ZM16.3281 3.56234V16.0311C16.3281 16.4248 16.1717 16.8023 15.8934 17.0807C15.615 17.3591 15.2374 17.5155 14.8438 17.5155H4.15625C3.76257 17.5155 3.38501 17.3591 3.10664 17.0807C2.82826 16.8023 2.67188 16.4248 2.67188 16.0311V3.56234C2.67188 3.16865 2.82826 2.7911 3.10664 2.51272C3.38501 2.23435 3.76257 2.07796 4.15625 2.07796H6.71902C7.07845 1.70263 7.51014 1.40393 7.98808 1.19988C8.46602 0.995822 8.98032 0.890625 9.5 0.890625C10.0197 0.890625 10.534 0.995822 11.0119 1.19988C11.4899 1.40393 11.9215 1.70263 12.281 2.07796H14.8438C15.2374 2.07796 15.615 2.23435 15.8934 2.51272C16.1717 2.7911 16.3281 3.16865 16.3281 3.56234ZM7.4434 4.45296H11.5566C11.4849 3.95867 11.2376 3.50673 10.8599 3.17989C10.4822 2.85304 9.99947 2.67315 9.5 2.67315C9.00053 2.67315 8.51778 2.85304 8.1401 3.17989C7.76242 3.50673 7.5151 3.95867 7.4434 4.45296ZM14.5469 3.85921H13.2547C13.324 4.15103 13.3591 4.44991 13.3594 4.74984V5.34359C13.3594 5.57979 13.2655 5.80633 13.0985 5.97335C12.9315 6.14038 12.705 6.23421 12.4688 6.23421H6.53125C6.29504 6.23421 6.06851 6.14038 5.90148 5.97335C5.73446 5.80633 5.64062 5.57979 5.64062 5.34359V4.74984C5.64087 4.44991 5.67599 4.15103 5.74527 3.85921H4.45312V15.7342H14.5469V3.85921Z"
      fill="#0C5097"
    />
  </svg>
);

const ViewMeetingModal = ({
  isOpen,
  onClose,
  meeting,
  currentUserId,
  onUpdate,
}) => {
  const { t, locale } = useI18n();
  const [meetingData, setMeetingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('details');
  const [previewFile, setPreviewFile] = useState(null);
  const [transcription, setTranscription] = useState(null);
  const [transcriptionLoading, setTranscriptionLoading] = useState(false);
  const [triggeringTranscription, setTriggeringTranscription] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = React.useRef(null);

  useEffect(() => {
    if (isOpen && meeting) {
      setLoading(true);
      setActiveTab('details');
      setTranscription(null);
      meetingService
        .show(meeting.id)
        .then((res) => setMeetingData(res.data))
        .catch((err) => {
          console.error(t('pages.meetings.load_details_error'), err);
          setMeetingData(meeting);
        })
        .finally(() => setLoading(false));
    }
  }, [isOpen, meeting]);

  useEffect(() => {
    if (activeTab !== 'minutes' || !meetingData) return;
    setTranscriptionLoading(true);
    meetingService
      .getTranscription(meetingData.id)
      .then((res) => setTranscription(res.data?.transcription || null))
      .catch(() => setTranscription(null))
      .finally(() => setTranscriptionLoading(false));
  }, [activeTab, meetingData]);

  const [minutesCopied, setMinutesCopied] = useState(false);

  const handleCopyMinutes = () => {
    if (!transcription?.content) return;
    const segments =
      transcription.content?.[locale] || transcription.content?.en || [];
    const text = segments
      .map((seg) => `${seg.user_name}: ${seg.text}`)
      .join('\n');
    navigator.clipboard.writeText(text).then(() => {
      setMinutesCopied(true);
      setTimeout(() => setMinutesCopied(false), 2000);
    });
  };

  const handleTriggerTranscription = async () => {
    if (!meetingData) return;
    setTriggeringTranscription(true);
    try {
      const res = await meetingService.triggerTranscription(meetingData.id);
      const data = res.data || res;
      if (data?.skipped) {
        setTranscription({ status: 'skipped' });
      } else {
        setTranscription({ status: 'pending' });
      }
    } catch (err) {
      notify('error', err?.message || 'Failed to start transcription');
    } finally {
      setTriggeringTranscription(false);
    }
  };

  const handleClose = () => {
    setMeetingData(null);
    setTranscription(null);
    onClose();
  };

  const handleRemoveMember = async (userId) => {
    if (!meetingData) return;
    try {
      const response = await meetingService.removeMember(
        meetingData.id,
        userId
      );
      if (response.status === true) {
        notify(
          'success',
          response.message || t('pages.meetings.member_removed')
        );
        const updatedMeeting = response.data || response;
        if (updatedMeeting && updatedMeeting.id) {
          setMeetingData(updatedMeeting);
          if (onUpdate) onUpdate(updatedMeeting);
        } else {
          setMeetingData((res) => {
            if (!res) return res;
            return {
              ...res,
              members: (res.members || []).filter((m) => m.id !== userId),
            };
          });
        }
      } else {
        notify(
          'error',
          response.message || t('pages.meetings.remove_member_error')
        );
      }
    } catch (err) {
      notify('error', err.message || t('pages.meetings.remove_member_error'));
    }
  };

  const handleDownloadAttachment = async (attachment) => {
    if (!meetingData) return;
    try {
      const response = await api.get(
        `/meetings/${meetingData.id}/attachments/${attachment.id}/download`,
        { responseType: 'blob' }
      );
      const blob = new Blob([response], { type: 'application/octet-stream' });
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = attachment.file_name || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error(t('pages.meetings.download_error'), error);
      notify('error', t('pages.meetings.download_error'));
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };

  const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const formatTime = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const getStatusBadge = (m) => {
    if (m.status === 'cancelled')
      return (
        <span className="vm-status-badge vm-status-cancelled">CANCELLED</span>
      );
    const now = new Date();
    const start = m.start_at ? new Date(m.start_at) : null;
    const end = m.end_at ? new Date(m.end_at) : null;
    if (start && end && now >= start && now <= end)
      return <span className="vm-status-badge vm-status-live">LIVE</span>;
    if (start && now < start)
      return (
        <span className="vm-status-badge vm-status-upcoming">UPCOMING</span>
      );
    return <span className="vm-status-badge vm-status-finished">FINISHED</span>;
  };

  const getOccurrenceLabel = (rule) => {
    if (!rule || rule.frequency === 'once') return null;
    let label =
      rule.frequency.charAt(0).toUpperCase() + rule.frequency.slice(1);
    if (rule.interval > 1) label += ` every ${rule.interval} ${rule.frequency}`;
    if (rule.days_of_week && rule.days_of_week.length > 0)
      label += ` (${rule.days_of_week.join(', ')})`;
    return label;
  };

  const getFileIcon = (fileName) => {
    const ext = (fileName || '').split('.').pop().toLowerCase();
    if (ext === 'pdf') return { icon: FaFilePdf, color: '#e53935' };
    if (['doc', 'docx'].includes(ext))
      return { icon: FaFileWord, color: '#1565c0' };
    if (['xls', 'xlsx', 'csv'].includes(ext))
      return { icon: FaFileExcel, color: '#2e7d32' };
    if (['ppt', 'pptx'].includes(ext))
      return { icon: FaFilePowerpoint, color: '#e65100' };
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext))
      return { icon: FaFileImage, color: '#6a1b9a' };
    if (['txt', 'md', 'log'].includes(ext))
      return { icon: FaFileAlt, color: '#37474f' };
    return { icon: FaFile, color: '#607d8b' };
  };

  const handlePreviewAttachment = (attachment) => {
    setPreviewFile(attachment);
  };

  const handleFileUpload = async (e, type = 'attachment') => {
    const files = Array.from(e.target.files);
    if (!files.length || !meetingData) return;
    e.target.value = '';

    setIsUploading(true);
    try {
      const formData = new FormData();
      files.forEach((file) => formData.append('files[]', file));
      formData.append('type', type);
      const response = await meetingService.uploadAttachments(
        meetingData.id,
        formData
      );
      if (response.status === true) {
        const updated = response.data;
        if (updated && updated.id) {
          setMeetingData(updated);
          if (onUpdate) onUpdate(updated);
        } else {
          const refreshed = await meetingService.show(meetingData.id);
          setMeetingData(refreshed.data);
        }
        notify(
          'success',
          response.message || t('pages.meetings.attachment_uploaded')
        );
      } else {
        notify(
          'error',
          response.message || t('common.messages.error') || 'Upload failed'
        );
      }
    } catch (err) {
      notify(
        'error',
        err?.message || t('common.messages.error') || 'Upload failed'
      );
    } finally {
      setIsUploading(false);
    }
  };

  if (!isOpen) return null;

  const renderPreview = () => {
    if (!previewFile) return null;
    return (
      <MeetingAttachmentPreviewModal
        attachment={previewFile}
        allAttachments={meetingData?.attachments || []}
        meetingId={meetingData?.id}
        onClose={() => setPreviewFile(null)}
      />
    );
  };

  const m = meetingData;

  const members = m?.members || [];
  const organizerInMembers = m?.organizer
    ? members.some((mem) => mem.id === m.organizer.id)
    : true;
  const attendees = [
    ...(m?.organizer && !organizerInMembers
      ? [
          {
            id: m.organizer.id,
            name: m.organizer.name,
            email: m.organizer.email,
            isOrganizer: true,
            rsvp: null,
            canRemove: false,
            colorIndex: 0,
          },
        ]
      : []),
    ...members.map((mem, i) => ({
      id: mem.id,
      name: mem.name,
      email: mem.email,
      isOrganizer: m?.organizer?.id === mem.id,
      rsvp: mem.rsvp_status,
      canRemove:
        m?.organizer?.id === currentUserId && mem.id !== m?.organizer?.id,
      colorIndex: organizerInMembers ? i : i + 1,
    })),
  ];
  const externalGuests = (m?.guest_invites || [])
    .filter((inv) => inv.status !== 'revoked')
    .map((inv, i) => ({
      id: inv.id,
      name: inv.email,
      email: inv.status,
      rsvp: inv.status,
      colorIndex: attendees.length + i,
    }));

  return (
    <>
      {renderPreview()}
      {ReactDOM.createPortal(
        <div
          className="project-composer-overlay vm-overlay"
          onClick={handleBackdropClick}
        >
          <div
            className="project-composer-modal vm-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="project-composer-header">
              <h2 className="project-composer-title">
                {t('pages.meetings.view_meeting') || 'Meeting Details'}
              </h2>
              <button className="project-composer-close" onClick={handleClose}>
                <FaTimes size={16} />
              </button>
            </div>

            {loading ? (
              <div className="project-composer-body">
                <ViewMeetingModalSkeleton />
              </div>
            ) : m ? (
              <>
                {/* Two-column split */}
                <div className="vm-body-split">
                  {/* ── Left panel ── */}
                  <div className="vm-left-panel">
                    {/* Tabs */}
                    <div className="vm-tabs-bar">
                      <button
                        className={`vm-tab${activeTab === 'details' ? ' vm-tab-active' : ''}`}
                        onClick={() => setActiveTab('details')}
                        type="button"
                      >
                        {t('pages.calendar.details.meeting_details') ||
                          'Meeting Details'}
                      </button>
                      <button
                        className={`vm-tab${activeTab === 'attachments' ? ' vm-tab-active' : ''}`}
                        onClick={() => setActiveTab('attachments')}
                        type="button"
                      >
                        {t('pages.calendar.schedule.attachments') ||
                          'Attachments'}
                      </button>
                      <button
                        className={`vm-tab${activeTab === 'minutes' ? ' vm-tab-active' : ''}`}
                        onClick={() => setActiveTab('minutes')}
                        type="button"
                      >
                        {t('pages.meetings.meeting_minutes') ||
                          'Meeting Minutes'}
                      </button>
                    </div>

                    {/* Details tab */}
                    {activeTab === 'details' && (
                      <div className="vm-details-content">
                        {/* Title row */}
                        <div className="vm-detail-row vm-detail-row-title">
                          <span className="vm-detail-label">
                            {t('pages.calendar.details.meeting_title') ||
                              'Meeting Title'}
                          </span>
                          <span className="vm-detail-value">{m.title}</span>
                        </div>

                        {/* Description box */}
                        {m.description && (
                          <div className="vm-description-box">
                            {m.description}
                          </div>
                        )}

                        <div className="vm-divider" />

                        {/* Date row */}
                        <div className="vm-detail-row">
                          <span className="vm-detail-label">
                            <CalendarIcon />{' '}
                            {t('pages.calendar.schedule.date') || 'Date'}
                          </span>
                          <span className="vm-detail-value vm-range-value">
                            <CalendarIcon />
                            {formatDate(m.start_at)}
                            {m.end_at && (
                              <>
                                <span className="vm-arrow">→</span>
                                <CalendarIcon />
                                {formatDate(m.end_at)}
                              </>
                            )}
                          </span>
                        </div>

                        {/* Time row */}
                        <div className="vm-detail-row">
                          <span className="vm-detail-label">
                            <TimeIcon />{' '}
                            {t('pages.calendar.schedule.time') || 'Time'}
                          </span>
                          <span className="vm-detail-value vm-range-value">
                            <TimeIcon />
                            {formatTime(m.start_at)}
                            {m.end_at && (
                              <>
                                <span className="vm-arrow">→</span>
                                <TimeIcon />
                                {formatTime(m.end_at)}
                              </>
                            )}
                          </span>
                        </div>

                        {/* Status row */}
                        <div className="vm-detail-row">
                          <span className="vm-detail-label">
                            <StatusIcon />{' '}
                            {t('pages.calendar.details.status') || 'Status'}
                          </span>
                          <span className="vm-detail-value">
                            {getStatusBadge(m)}
                          </span>
                        </div>

                        {/* Occurrence row */}
                        {m.recurrence_rule &&
                          m.recurrence_rule.frequency !== 'once' &&
                          (() => {
                            const label = getOccurrenceLabel(m.recurrence_rule);
                            return label ? (
                              <div className="vm-detail-row">
                                <span className="vm-detail-label">
                                  <OccurrenceIcon />{' '}
                                  {t('pages.calendar.schedule.occurrence') ||
                                    'Occurrence'}
                                </span>
                                <span className="vm-detail-value vm-range-value">
                                  {label}
                                  {m.recurrence_rule.recurrence_end_date && (
                                    <>
                                      <span className="vm-arrow">→</span>
                                      <CalendarIcon />
                                      {formatDate(
                                        m.recurrence_rule.recurrence_end_date
                                      )}
                                    </>
                                  )}
                                </span>
                              </div>
                            ) : null;
                          })()}

                        {/* Location row */}
                        <div className="vm-detail-row">
                          <span className="vm-detail-label">
                            <LocationIcon />{' '}
                            {t('pages.calendar.schedule.location') ||
                              'Location'}
                          </span>
                          <span className="vm-detail-value">
                            {m.is_online
                              ? t('pages.calendar.schedule.online_meeting') ||
                                'Online Meeting'
                              : m.location || '-'}
                          </span>
                        </div>

                        {/* Cancellation reason */}
                        {m.status === 'cancelled' && m.cancellation_reason && (
                          <div className="vm-detail-row">
                            <span className="vm-detail-label vm-cancel-label">
                              {t('pages.meetings.cancellation_message') ||
                                'Cancellation Message'}
                            </span>
                            <span className="vm-detail-value vm-cancel-value">
                              {m.cancellation_reason}
                            </span>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Attachments tab */}
                    {activeTab === 'attachments' && (
                      <div className="vm-details-content">
                        {/* Upload field */}
                        <div className="vm-upload-group">
                          <label className="vm-upload-label">
                            {t('pages.meetings.upload_attachment')}:
                          </label>
                          <div className="vm-upload-row">
                            <UploadIcon />
                            <label
                              className={`vm-upload-input-label${isUploading ? ' vm-upload-disabled' : ''}`}
                            >
                              <span>
                                {isUploading
                                  ? t('pages.meetings.uploading_attachment')
                                  : t(
                                      'pages.calendar.schedule.upload_document'
                                    )}
                              </span>
                              <input
                                ref={fileInputRef}
                                type="file"
                                multiple
                                onChange={(e) =>
                                  handleFileUpload(e, 'attachment')
                                }
                                disabled={isUploading}
                                className="vm-upload-input-hidden"
                              />
                            </label>
                          </div>
                        </div>

                        {(() => {
                          const tabAttachments = (m.attachments || []).filter(
                            (a) => (a.type ?? 'attachment') === 'attachment'
                          );
                          return tabAttachments.length > 0 ? (
                            <div className="vm-attachments-list">
                              {tabAttachments.map((att) => {
                                const { icon: FileIcon, color } = getFileIcon(
                                  att.file_name
                                );
                                return (
                                  <div
                                    key={att.id}
                                    className="vm-attachment-row"
                                  >
                                    <div
                                      className="vm-attachment-icon"
                                      style={{ color }}
                                    >
                                      <FileIcon size={36} />
                                    </div>
                                    <div className="vm-attachment-info">
                                      <div className="vm-attachment-name">
                                        {att.file_name}
                                      </div>
                                      <div className="vm-attachment-meta">
                                        {parseDate(att.uploaded_at)?.dmyTime ??
                                          ''}
                                      </div>
                                    </div>
                                    <div className="vm-attachment-actions">
                                      <button
                                        className="vm-att-btn"
                                        onClick={() =>
                                          handlePreviewAttachment(att)
                                        }
                                        title="Preview"
                                      >
                                        <ViewIcon />
                                      </button>
                                      <button
                                        className="vm-att-btn"
                                        onClick={() =>
                                          handleDownloadAttachment(att)
                                        }
                                        title="Download"
                                      >
                                        <DownloadIcon />
                                      </button>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="vm-empty">
                              {t('pages.meetings.no_attachments')}
                            </div>
                          );
                        })()}
                      </div>
                    )}

                    {/* Minutes tab */}
                    {activeTab === 'minutes' && (
                      <div className="vm-details-content">
                        {/* Heading row — title left, generate button right */}
                        <div className="vm-minutes-heading">
                          <MeetingMinutesIcon />
                          <span>{t('pages.meetings.meeting_minutes')}</span>
                          {!transcriptionLoading &&
                            meetingData?.has_recording &&
                            meetingData?.organizer?.id === currentUserId && (
                              <button
                                className="vm-generate-transcription-btn"
                                onClick={handleTriggerTranscription}
                                disabled={triggeringTranscription}
                                type="button"
                              >
                                {triggeringTranscription
                                  ? t('pages.meetings.transcription_starting')
                                  : t('pages.meetings.generate_transcription')}
                              </button>
                            )}
                        </div>

                        {/* Minutes upload field */}
                        <div className="vm-upload-group">
                          <label className="vm-upload-label">
                            {t('pages.meetings.upload_attachment')}:
                          </label>
                          <div className="vm-upload-row">
                            <UploadIcon />
                            <label
                              className={`vm-upload-input-label${isUploading ? ' vm-upload-disabled' : ''}`}
                            >
                              <span>
                                {isUploading
                                  ? t('pages.meetings.uploading_attachment')
                                  : t(
                                      'pages.calendar.schedule.upload_document'
                                    )}
                              </span>
                              <input
                                type="file"
                                multiple
                                onChange={(e) => handleFileUpload(e, 'minutes')}
                                disabled={isUploading}
                                className="vm-upload-input-hidden"
                              />
                            </label>
                          </div>
                        </div>

                        {/* Minutes files list */}
                        {(() => {
                          const minutesFiles = (m.attachments || []).filter(
                            (a) => a.type === 'minutes'
                          );
                          return minutesFiles.length > 0 ? (
                            <div className="vm-attachments-list vm-minutes-files-list">
                              {minutesFiles.map((att) => {
                                const { icon: FileIcon, color } = getFileIcon(
                                  att.file_name
                                );
                                return (
                                  <div
                                    key={att.id}
                                    className="vm-attachment-row"
                                  >
                                    <div
                                      className="vm-attachment-icon"
                                      style={{ color }}
                                    >
                                      <FileIcon size={36} />
                                    </div>
                                    <div className="vm-attachment-info">
                                      <div className="vm-attachment-name">
                                        {att.file_name}
                                      </div>
                                      <div className="vm-attachment-meta">
                                        {parseDate(att.uploaded_at)?.dmyTime ??
                                          ''}
                                      </div>
                                    </div>
                                    <div className="vm-attachment-actions">
                                      <button
                                        className="vm-att-btn"
                                        onClick={() =>
                                          handlePreviewAttachment(att)
                                        }
                                        title="Preview"
                                      >
                                        <ViewIcon />
                                      </button>
                                      <button
                                        className="vm-att-btn"
                                        onClick={() =>
                                          handleDownloadAttachment(att)
                                        }
                                        title="Download"
                                      >
                                        <DownloadIcon />
                                      </button>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : null;
                        })()}

                        {transcriptionLoading ? (
                          <div className="vm-minutes-skeleton">
                            {Array.from({ length: 3 }).map((_, i) => (
                              <div
                                key={i}
                                className="vm-minutes-skeleton-segment"
                              >
                                <div className="vm-minutes-skeleton-meta">
                                  <div className="vm-minutes-skeleton-speaker" />
                                  <div className="vm-minutes-skeleton-time" />
                                </div>
                                <div className="vm-minutes-skeleton-line" />
                                <div className="vm-minutes-skeleton-line vm-minutes-skeleton-line-short" />
                              </div>
                            ))}
                          </div>
                        ) : transcription?.status === 'completed' ? (
                          <>
                            {(
                              transcription.content?.[locale] ||
                              transcription.content?.en ||
                              []
                            ).length > 0 && (
                              <div className="vm-copy-minutes-row">
                                <div className="vm-copy-minutes-wrapper">
                                  <button
                                    type="button"
                                    className="vm-copy-minutes-btn"
                                    onClick={handleCopyMinutes}
                                  >
                                    <CopyMinutesIcon />
                                    <span>
                                      {t('pages.meetings.copy_minutes')}
                                    </span>
                                  </button>
                                  {minutesCopied && (
                                    <span className="vm-copy-minutes-tooltip">
                                      {t('pages.meetings.copied')}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                            <div className="vm-transcription">
                              {(
                                transcription.content?.[locale] ||
                                transcription.content?.en ||
                                []
                              ).map((seg, i) => (
                                <div
                                  key={i}
                                  className="vm-transcription-segment"
                                >
                                  <div className="vm-transcription-meta">
                                    <span className="vm-transcription-speaker">
                                      {seg.user_name}
                                    </span>
                                    <span className="vm-transcription-time">
                                      {formatTranscriptionTime(seg.start_sec)} –{' '}
                                      {formatTranscriptionTime(seg.end_sec)}
                                    </span>
                                  </div>
                                  <p className="vm-transcription-text">
                                    {seg.text}
                                  </p>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : transcription?.status === 'processing' ||
                          transcription?.status === 'pending' ? (
                          <div className="vm-empty">
                            {t('pages.meetings.transcription_in_progress')}
                          </div>
                        ) : (
                          <div className="vm-empty">
                            {transcription?.status === 'failed'
                              ? t('pages.meetings.transcription_failed')
                              : t('pages.meetings.transcription_unavailable')}
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* ── Right panel: Attendees ── */}
                  <div className="vm-right-panel">
                    <div className="vm-attendees-header">
                      <AttendeesIcon />
                      <span>
                        {t('pages.calendar.details.attendees') || 'Attendees'}
                      </span>
                    </div>

                    <div className="vm-attendees-list">
                      {attendees.length === 0 &&
                        externalGuests.length === 0 && (
                          <div className="vm-empty">
                            {t('pages.meetings.no_members') || 'No attendees'}
                          </div>
                        )}

                      {attendees.map((attendee) => (
                        <div key={attendee.id} className="vm-attendee-row">
                          <div
                            className="vm-attendee-avatar"
                            style={{
                              backgroundColor: getAvatarColor(
                                attendee.colorIndex
                              ),
                            }}
                          >
                            {attendee.name?.charAt(0).toUpperCase() || '?'}
                          </div>
                          <div className="vm-attendee-info">
                            <div className="vm-attendee-name">
                              {attendee.name}
                            </div>
                            <div className="vm-attendee-email">
                              {attendee.email}
                            </div>
                          </div>
                          <div className="vm-attendee-actions">
                            {attendee.isOrganizer && (
                              <span className="vm-organizer-badge">
                                {t('pages.calendar.details.organizer') ||
                                  'Organizer'}
                              </span>
                            )}
                            {!attendee.isOrganizer && attendee.rsvp && (
                              <span
                                className={`vm-rsvp-badge vm-rsvp-${attendee.rsvp}`}
                              >
                                {attendee.rsvp}
                              </span>
                            )}
                            {attendee.canRemove && (
                              <button
                                className="vm-remove-btn"
                                title={t('pages.meetings.remove_member')}
                                onClick={() => handleRemoveMember(attendee.id)}
                              >
                                <FaTimes size={11} />
                              </button>
                            )}
                          </div>
                        </div>
                      ))}

                      {externalGuests.length > 0 && (
                        <>
                          <div className="vm-guests-label">
                            {t('pages.calendar.schedule.external_guests') ||
                              'Invite Members (Outside Organization)'}
                          </div>
                          {externalGuests.map((guest) => (
                            <div key={guest.id} className="vm-attendee-row">
                              <div
                                className="vm-attendee-avatar"
                                style={{
                                  backgroundColor: getAvatarColor(
                                    guest.colorIndex
                                  ),
                                }}
                              >
                                {guest.name?.charAt(0).toUpperCase() || '?'}
                              </div>
                              <div className="vm-attendee-info">
                                <div className="vm-attendee-name">
                                  {guest.name}
                                </div>
                                <div className="vm-attendee-email">
                                  {guest.email}
                                </div>
                              </div>
                              <div className="vm-attendee-actions">
                                <span
                                  className={`vm-rsvp-badge vm-rsvp-${guest.rsvp}`}
                                >
                                  {guest.rsvp}
                                </span>
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="project-composer-footer">
                  <button
                    className="project-composer-btn project-composer-btn-secondary"
                    onClick={handleClose}
                  >
                    {t('common.actions.close') || 'Close'}
                  </button>
                </div>
              </>
            ) : null}
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default ViewMeetingModal;
